import { z } from 'zod';

import { emailSchema, idSchema, strongPasswordSchema } from './common';

export const userPublicSchema = z.object({
  id: idSchema,
  email: emailSchema,
  name: z.string(),
  isSuperAdmin: z.boolean(),
  avatarAttachmentId: z.string().nullable(),
  timezone: z.string(),
});
export type UserPublic = z.infer<typeof userPublicSchema>;

export const updateProfileInputSchema = z.object({
  name: z.string().trim().min(1).max(120).optional(),
  avatarAttachmentId: z.string().nullable().optional(),
  timezone: z.string().min(1).max(64).optional(),
  notifyOnAssign: z.boolean().optional(),
  notifyOnMention: z.boolean().optional(),
});
export type UpdateProfileInput = z.infer<typeof updateProfileInputSchema>;

export const changePasswordInputSchema = z.object({
  currentPassword: z.string().min(1),
  newPassword: strongPasswordSchema,
});
export type ChangePasswordInput = z.infer<typeof changePasswordInputSchema>;
